export default {
  methods: {
    // 获取当前路由的真实项目ID
    getRealProjectId() {
      const routeId = this.$route.query.id;
      if (routeId) {
        return routeId;
      }
      return null;
    },
    
    // 生成URL
    generateUrl(path, realId, additionalParams = {}) {
      const query = { id: realId, ...additionalParams };
      return this.$router.resolve({ path, query }).href;
    }
  }
}; 